import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
   
import { useRef } from 'react'; // Add this at the top of your file

const Supplierssituation = () => {

   const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  const [tableWidth, setTableWidth] = useState(0);

  useEffect(() => {
    const topScroll = topScrollRef.current;
    const tableContainer = tableContainerRef.current;

    if (!topScroll || !tableContainer) return;

    // Set the width of the top scrollbar to match table content width
    const table = tableContainer.querySelector('table');
    if (table) {
      setTableWidth(table.scrollWidth);
    }

    // Sync top scrollbar with table scroll
    const handleTableScroll = () => {
      topScroll.scrollLeft = tableContainer.scrollLeft;
    };

    // Sync table scroll with top scrollbar
    const handleTopScroll = () => {
      tableContainer.scrollLeft = topScroll.scrollLeft;
    };

    tableContainer.addEventListener('scroll', handleTableScroll);
    topScroll.addEventListener('scroll', handleTopScroll);

    return () => {
      tableContainer.removeEventListener('scroll', handleTableScroll);
      topScroll.removeEventListener('scroll', handleTopScroll);
    };
  }, []);

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
    const [permission, setPermission] = useState({});
    const [overviewdata, setOverviewdata] = useState({});
  let season_id = localStorage.getItem("season_id");
  let para ={season_id:season_id};
  useEffect(() => {
        setPermission(FindModuleById(457)); 
        console.log(permission);
        axios.post("/finance-supplier-situation/listing",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.suppliers);
          setOverviewdata(response.data.data.overview);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  
    const SupplierCell = ({ row }) => (
      <a href={`/financesuppliersituation-detail/${row.original.supplier_id}`} className="">
        {row.original.supplier_name || ""}
      </a>
    );
    
    SupplierCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          supplier_id: PropTypes.number,
          supplier_name: PropTypes.string,
        }),
      }),
    };
const columns =
 [
    {
      header: 'Supplier',
      accessorKey: 'supplier_name',
      Cell: SupplierCell,
    },

    // {
    //   accessorKey: 'supplier_name', 
    //   header: 'Supplier',
    // },
    {
      accessorKey: 'total_amount', 
      header: 'Total Amount',
    },
    {
      accessorKey: 'paid_amount', 
      header: 'Paid Amount',
    },
     {
      accessorKey: 'open_amount', 
      header: 'Open Amount',
    },
    {
      accessorKey: 'credit_note', 
      header: 'Credit Note Amount',
    },
  ];




  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title"> Suppliers Situation</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Suppliers Situation</li>
                </ul>
              </div>
          
            </div>
          </div>
          <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Amount</div>
                          <div className="dash-counts">
                            <p>{overviewdata.total_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Paid Amount </div>
                          <div className="dash-counts">
                            <p>{overviewdata.paid_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Open amount  </div>
                          <div className="dash-counts">
                            <p>{overviewdata.open_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Credit Notes  </div>
                          <div className="dash-counts">
                            <p>{overviewdata.credit_note}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                      
                </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    <div 
                        ref={topScrollRef}
                        style={{
                          overflowX: 'auto',
                          overflowY: 'hidden',
                          height: '17px',
                          marginBottom: '8px',
                          border: '1px solid #e0e0e0',
                          borderRadius: '4px'
                        }}
                      >
                        <div style={{ width: `${tableWidth}px`, height: '1px' }} />
                  </div>

                  {permission?.list == 1 && ( 
                    <MaterialReactTable columns={columns} data={data} 
                    enableColumnOrdering
                      muiTableContainerProps={{
                        ref: tableContainerRef,
                      }}
                   
                  />
                  )}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Supplierssituation;
